import {
    Fragment,
    useCallback,
    useEffect,
    useRef,
    useState,
} from 'react'
import { Menu, Transition } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/solid'
import { classNames } from '@progress/kendo-react-common'
import { DropPosition } from '../common'
import { ServiceApiItem } from 'types/service'
import React from 'react'

type SelectorProps = {
    className?: string
    position?: DropPosition
    items: ServiceApiItem[] | any[]
    overrideServices: any[]
    selected?: ServiceApiItem
    updateServices(services: any[]): void
    title?: string
    id?: number
    update_on_select: boolean
    disabled?: boolean
    icon: string
}
export function ServiceAvailSelector(props: SelectorProps) {
    const [selected_services, setSelectedServices] = useState<any[]>(props?.items.map((item) => item.id))
    const buttonRef = useRef(null); // Ref for the button
  const [menuWidth, setMenuWidth] = useState('auto'); // State to hold the width

  useEffect(() => {
    // Update the width of the menu items when the component mounts
    if (buttonRef.current) {
      setMenuWidth(buttonRef.current.offsetWidth + 'px');
    }
  }, [buttonRef.current]);

    useEffect(() => {
        if (props.overrideServices && props.overrideServices.length != 0) {
            setSelectedServices(props.overrideServices.map((item) => item.id))
        }
    }, [props.overrideServices])

    useEffect(() => {
        if (props.update_on_select) {
            props?.updateServices(selected_services)
        }
    }, [selected_services])

    function handleSelectedItem(idx: number, is_selected: boolean) {
        if (is_selected) {
            setSelectedServices((prev) => {
                const item = props.items[idx].id
                return prev.includes(item)
                    ? prev
                    : [...prev, item]
            })
        } else {
            setSelectedServices((prev) =>
                prev.filter((item) => item !== props.items[idx].id)
            )
        }
    }

    const toggleSelectAll = () => {
        setSelectedServices((prev) => {
            let prevState = [...prev]
            let temp: string[] = []
            if (prevState.length !== props.items.length) {
                temp = props.items.map((itm) => itm.id)
            }
            return temp
        })
    }

    const getServicesTitle = useCallback(() => {
        const is_all =
            selected_services.length === props.items.length
        const title_1 = !is_all
            ? `${selected_services.length} ${props.title}${selected_services.length === 1 ? '' : 's'
            }`
            : `All ${props.title}s`

        return title_1.includes('undefined' || undefined) ? '' : title_1
    }, [props.title, selected_services])

    return (
        <Menu
            as="div"
            className={classNames(
                'inline-block text-left',
                props.className
            )}
            key={props?.id}
        >
            {({ open }) => (
                <>
                    <Menu.Button
                        ref={buttonRef}
                        disabled={props.disabled}
                        className='flex justify-between items-center rounded-md p-1 bg-white w-full hover:bg-gray-50 flex disabled:opacity-50 disabled:cursor-not-allowed'
                        onClickCapture={() => {
                            props?.updateServices(selected_services)
                        }}
                    >
                        <div>
                            <i className={classNames(props.icon, "text-xs mr-2")} />
                            <span>{getServicesTitle()}</span>
                        </div>
                        <div>
                            <ChevronDownIcon
                                className="relative ml-1 items-center h-5 w-5 right-0"
                                aria-hidden="true"
                            />
                        </div>
                    </Menu.Button>
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                        show={open}
                    >
                        <Menu.Items
                            static
                            style={{ width: menuWidth }}
                            className={classNames(
                                props.position,
                                'absolute mt-2 z-50',
                                'rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5',
                                'focus:outline-none'
                            )}
                        >
                            <Menu.Item key={'allServices'}>
                                {({ active }) => (
                                    <div
                                        className={classNames(
                                            active
                                                ? 'bg-gray-100 text-gray-900'
                                                : 'text-gray-700',
                                            'block text-sm'
                                        )}
                                    >
                                        <label className="block min-w-0 flex-1 text-gray-500 h-full px-3 py-2">
                                            <input
                                                name="filter_service[]"
                                                type="checkbox"
                                                value={''}
                                                checked={
                                                    selected_services.length ===
                                                    props.items.length
                                                }
                                                onChange={toggleSelectAll}
                                                className="h-4 w-4 mr-2 border-gray-300 rounded text-primary focus:ring-primary-light"
                                            />
                                            All {props?.title}s
                                        </label>
                                    </div>
                                )}
                            </Menu.Item>
                            <hr />
                            <div
                                className="py-1"
                                style={{
                                    paddingTop: '20px',
                                    overflowX: 'auto',
                                    maxHeight: '50vh',
                                }}
                            >
                                {props.items && props.items.length
                                    ? props.items.map(
                                        (i: ServiceApiItem, idx) => {
                                            return (
                                                <Menu.Item key={idx}>
                                                    {({ active }) => (
                                                        <div
                                                            className={classNames(
                                                                active
                                                                    ? 'bg-gray-100 text-gray-900'
                                                                    : 'text-gray-700',
                                                                'block text-sm z-40'
                                                            )}
                                                        >
                                                            <label
                                                                htmlFor={`filter-${idx}`}
                                                                className="flex min-w-0 flex-1 text-gray-500 h-full px-3 py-2"
                                                            >
                                                                <input
                                                                    id={`filter-${idx}`}
                                                                    name="filter_service[]"
                                                                    type="checkbox"
                                                                    value={
                                                                        idx
                                                                    }
                                                                    checked={
                                                                        selected_services.includes(
                                                                            i.id
                                                                        ) ||
                                                                        false
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        handleSelectedItem(
                                                                            idx,
                                                                            e.target.checked
                                                                        )
                                                                    }}
                                                                    className="h-4 w-4 mr-2 border-gray-300 rounded text-primary focus:ring-primary-light"
                                                                />
                                                                <span>
                                                                    {
                                                                        i.name
                                                                    }
                                                                </span>
                                                            </label>
                                                        </div>
                                                    )}
                                                </Menu.Item>
                                            )
                                        }
                                    )
                                    : ''}
                            </div>
                        </Menu.Items>
                    </Transition>
                </>
            )}
        </Menu>
    )
}

export default ServiceAvailSelector
